import * as React from 'react';

function SvgZippayColourSquare(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="ZippayColourSquare_svg__a"
        maskUnits="userSpaceOnUse"
        x={6}
        y={6}
        width={19}
        height={12}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.358 6.101h18.586v11.633H6.358V6.101z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#ZippayColourSquare_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.62 13.003l-4.205 3.745H8.997a4.003 4.003 0 00-2.639.986l5.255-4.68.08-.07 6.583-5.868a4.027 4.027 0 013.909-.82 3.97 3.97 0 012.672 2.94 3.932 3.932 0 01-1.236 3.762v.005z"
          fill="#F15B41"
        />
      </g>
      <mask
        id="ZippayColourSquare_svg__b"
        maskUnits="userSpaceOnUse"
        x={5}
        y={6}
        width={8}
        height={9}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 6.106h7.994v7.913H5V6.106z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#ZippayColourSquare_svg__b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.997 6.106c2.207 0 3.997 1.771 3.997 3.956s-1.79 3.957-3.997 3.957C6.789 14.019 5 12.247 5 10.062c0-2.185 1.79-3.956 3.997-3.956z"
          fill="#F99D1D"
        />
      </g>
      <mask
        id="ZippayColourSquare_svg__c"
        maskUnits="userSpaceOnUse"
        x={5}
        y={16}
        width={15}
        height={9}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 16.748h14.415v7.914H5v-7.914z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#ZippayColourSquare_svg__c)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.997 16.748a4.003 4.003 0 00-2.639.986l-.034.03a3.928 3.928 0 00-.298 5.587 4.025 4.025 0 005.643.296l7.746-6.898H8.997z"
          fill="#272560"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.409 16.751l-7.747 6.898a4.004 4.004 0 01-2.672 1.01h11.952c2.305-.036 3.932-1.753 3.932-3.956 0-2.203-1.75-3.921-3.932-3.956l-1.533.004z"
        fill="#00B6BD"
      />
    </svg>
  );
}

export default SvgZippayColourSquare;
